<div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 5px;font-family: Roboto, Helvetica Neue, sans-serif;">
  <mat-form-field>
    <mat-select placeholder="Filtrer par versements..."
                [matTooltip]="'Filtrer sur des versements...'"
                [formControl]="depositControl"
                multiple
                (selectionChange)="onSelected($event)">
        <mat-option *ngFor="let deposit of deposits" [value]="deposit">
            {{deposit}}
        </mat-option>
    </mat-select>
  </mat-form-field>
  <div>
    <button color="accent" class="mat-button mat-small" mat-raised-button (click)="onValidate($event)" matTooltip="Filtrer" data-cy="btn-dir-cmp-deposits-filtering">Filtrer</button>&nbsp;
  </div>
</div>
